<template>
  <transition-group
    name="list"
    tag="div"
    :css="false"
    v-on:before-enter="handleBeforeEnter"
    v-on:enter="handleEnter"
    v-on:after-enter="handleAfterEnter"
  >
    <slot></slot>
  </transition-group>
</template>

<script>
export default {
  name: 'cc-animation-list',
  props: {
    interval: {
      type: [Number, String],
      default: 300
    }
  },
  data () {
    return {
      delay: 0
    }
  },
  methods: {

    handleBeforeEnter (dom) {
      dom.classList.add('list-enter', 'list-enter-active')
    },
    handleEnter (dom, done) {
      let delay = this.delay++ * this.interval
      setTimeout(() => {
        dom.classList.remove('list-enter')
        dom.classList.add('list-enter-to')
        // 监听 transitionend 事件
        const transitionend = window.ontransitionend ? 'transitionend' : 'webkitTransitionEnd'
        dom.addEventListener(transitionend, function onEnd () {
          dom.removeEventListener(transitionend, onEnd)
          // 调用done() 告诉vue动画已完成，以触发 afterEnter 钩子
          done()
          dom.classList.remove('list-enter-active', 'list-enter-to')
        })
      }, delay)
    },
    handleAfterEnter () {
      this.delay--
    }
  }
}
</script>
